





































import { Component, Prop, Vue } from 'vue-property-decorator'

import { ListItem } from '@/layouts/components'

import { QrCode } from '@/models'

import QrCodeImage from './QrCodeImage.vue'

@Component({
  components: {
    ListItem,
    QrCodeImage
  }
})
export default class QrCodeTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly qrCode!: QrCode
}
